<template>
  <div id="AddApCourse" class="wrap">

    <v-app-bar extended extension-height="10" class="grey lighten-3 hidden-md-and-up"  fixed  elevate-on-scroll  >
      <v-layout column align-center class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center">Add AP Course</span>
      </v-layout>
    </v-app-bar>
    <div class="maxContainer">
      <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
      </div>
     <v-card class=" mb-5 pt-5 offset-md-3 col-md-6 offset-sm-2 col-sm-8" flat >
        <v-card-text class="mt-0 pt-0 px-0">
        <v-container  grid-list-md pt-0 pl-0 pr-0 >
            <v-layout column align-center class="justify-center mb-3 hidden-sm-and-down">
        <span class="title light-blue--text text--darken-3 text-center">Add AP Course</span>
      </v-layout>
          <v-form>

            <v-flex xs12>
              <v-autocomplete
                v-model="course_id"
                :items="courses"
                item-text= "course_name"
                hide-selected
                item-value="id"
                label="Select Course"
                color="green"
                clearable
                outlined

                >

              </v-autocomplete>
            </v-flex>


            <v-flex xs12 >

              <v-autocomplete
                v-model="course_grade"
                class="mt-2 pt-0"
                :items="['1', '2', '3', '4', '5',]"
                label="Score"
                color="green"
                clearable
                outlined

              ></v-autocomplete>

            </v-flex>
          </v-form>
          <!-- Add Course Button -->
          <v-layout row >

            <v-btn
              class="mt-3"
              color="green"
              @click="addCourse"
              block
              large
              depressed
              :disabled="checkAddCourse"
            >

              <span class="white--text"> Add Course</span>
            </v-btn>

          </v-layout>
        </v-container>
       </v-card-text>
      </v-card>
    </div>
     <!-- Back Button -->
     <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>
</template>

<script>
export default {
  data () {
    return {
      course_id : '',
      course_grade: '',
    }
  },
  methods: {
    back() {
        this.$router.go(-1)
    },
    addCourse () {
        var course_gpa_calculation = ''
        var course_subject_category = ''
        var name = ''

        for (var c = 0; c < this.courses.length; c++) {
          if(this.courses[c].id === this.course_id ) {
             course_gpa_calculation = this.courses[c].course_gpa_calculation
             course_subject_category = this.courses[c].course_subject_category
             name = this.courses[c].course_name
          }
        }


        const apCourseData = {
          collegeId: this.collegeId,
          course_id : this.course_id,
          course_name : name,
          course_grade: this.course_grade,
          course_gpa_calculation : course_gpa_calculation,
          course_subject_category: course_subject_category,
        }

        console.log(apCourseData)
        this.$store.dispatch('setApCourse', apCourseData)
        this.$router.go(-1)
      }
  },
  computed : {
    collegeId () {
        return this.$route.params.collegeId
      },
    checkAddCourse () {
      if( this.course_id !== '' && this.course_credits !== '' && this.course_lab !== '' ){
        return false
      } else {
        return true
      }

    },
    courses() {
      return this.$store.getters.loadedCourses
    }

  },
}
</script>

<style scoped>
  #headerToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;
}

 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Apcourses/AddApCourse.vue